var _path, _g, _g2, _g3, _g4, _rect, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7, _circle7, _rect8, _circle8, _rect9, _circle9, _rect0, _circle0, _rect1, _circle1, _rect10, _circle10, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 2.2472C20.8034 2.2473 24.2948 4.60066 25.7822 5.98939C26.1384 6.32196 26.2955 6.46872 26.4746 6.88099C26.6521 7.28962 26.6543 7.59694 26.6543 8.29115V21.5275C26.6543 22.3326 26.6518 22.694 26.5332 23.0343C26.4146 23.3748 26.2018 23.6469 25.7227 24.2511C22.6964 28.0674 20.2406 30.2609 16.2539 32.6701C15.218 33.2961 14.7534 33.5702 14.1816 33.5812C13.6099 33.5921 13.1385 33.3379 12.0859 32.756C7.94138 30.4648 5.46237 28.2719 2.53809 24.1945C2.12956 23.6248 1.94803 23.3692 1.8457 23.0509C1.74348 22.7329 1.74121 22.4009 1.74121 21.6613V8.29115C1.74121 7.59694 1.74338 7.28962 1.9209 6.88099C2.10006 6.46867 2.25708 6.32197 2.61328 5.98939C4.10066 4.60065 7.5927 2.2472 14.1982 2.2472Z",
    stroke: "#182C61",
    strokeOpacity: 0.2,
    strokeWidth: 0.361853
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3135_25318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64746 11.2047C4.64746 10.2532 4.64746 9.77745 5.00347 9.06884C5.35948 8.36024 5.59425 8.18556 6.06381 7.8362C7.48697 6.77735 10.096 5.49615 14.3894 5.49615C18.6827 5.49615 21.2918 6.77735 22.7149 7.8362C23.1845 8.18556 23.4193 8.36024 23.7753 9.06884C24.1313 9.77745 24.1313 10.2532 24.1313 11.2047V19.4679C24.1313 20.6107 24.1313 21.1821 23.9317 21.7337C23.7321 22.2852 23.3995 22.6846 22.7343 23.4835C21.0273 25.5335 19.4811 26.9532 17.4109 28.341C16.0354 29.2632 15.3476 29.7242 14.3584 29.7395C13.3692 29.7548 12.6796 29.3227 11.3004 28.4585C9.11921 27.0918 7.54259 25.6307 5.84713 23.3954C5.28005 22.6477 4.99651 22.2739 4.82198 21.755C4.64746 21.2361 4.64746 20.7102 4.64746 19.6583V11.2047Z",
    fill: "#55E6C1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3135_25318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46387 10.9978C6.46387 10.5622 6.46387 10.3445 6.59152 10.0639C6.71917 9.78337 6.83734 9.6804 7.07369 9.47447C8.04106 8.63156 10.2556 7.25222 14.3895 7.25222C18.5234 7.25222 20.7379 8.63156 21.7053 9.47447C21.9416 9.6804 22.0598 9.78337 22.1875 10.0639C22.3151 10.3445 22.3151 10.5622 22.3151 10.9978V19.5465C22.3151 20.1954 22.3151 20.5198 22.2084 20.8268C22.1016 21.1337 21.9086 21.3775 21.5226 21.8652C19.6858 24.1861 18.1467 25.7029 15.6838 27.232C15.0764 27.6091 14.7727 27.7977 14.3822 27.8052C13.9917 27.8128 13.6828 27.6372 13.0651 27.286C10.493 25.8237 8.93165 24.2996 7.14245 21.8123C6.81371 21.3553 6.64934 21.1268 6.5566 20.8391C6.46387 20.5514 6.46387 20.2529 6.46387 19.656L6.46387 10.9978Z",
    fill: "#4846BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_3135_25318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.441,
    cy: 8.13138,
    r: 2.53569,
    fill: "#4846BC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_3135_25318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1846 17.3704L12.9845 20.1758L18.4678 14.6818",
    stroke: "#D4D1F7",
    strokeWidth: 2.36664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.927377,
    y: 6.13723,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.92266,
    cy: 7.13235,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5328,
    y: 6.13723,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5281,
    cy: 7.13235,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.927377,
    y: 22.0588,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.92266,
    cy: 23.0539,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9444,
    y: 2.84308,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5246,
    cy: 3.4237,
    r: 0.316622,
    fill: "#4846BC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.10843,
    y: 2.84308,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.68869,
    cy: 3.4237,
    r: 0.316622,
    fill: "#4846BC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9444,
    y: 28.3535,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5246,
    cy: 28.9338,
    r: 0.316622,
    fill: "#4846BC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.10843,
    y: 28.3535,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.68869,
    cy: 28.9338,
    r: 0.316622,
    fill: "#4846BC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5328,
    y: 22.0588,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5281,
    cy: 23.0539,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2301,
    y: 32.5526,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2254,
    cy: 33.5477,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2301,
    y: 1.07152,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2254,
    cy: 2.06661,
    r: 0.54278,
    fill: "#4846BC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1.22367,
    y: 14.5128,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.80393,
    cy: 15.0932,
    r: 0.316622,
    fill: "#4846BC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0108,
    y: 14.5128,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "#4846BC",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.591,
    cy: 15.0932,
    r: 0.316622,
    fill: "#4846BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4752 29.1159L82.8629 28.3951L82.0205 26.6591H82.5069L83.0868 27.9456L83.6736 26.6591H84.1636L82.9511 29.1159H82.4752Z",
    fill: "#182C61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.195 28.411H79.7314L79.7367 25.9542H80.195V26.8037C80.3941 26.6874 80.6549 26.6204 80.8929 26.6204H80.9863C81.3511 26.6204 81.6525 26.779 81.8217 27.054C81.9926 27.3289 81.9908 27.7484 81.8217 28.018C81.6525 28.293 81.3511 28.4516 80.9863 28.4516H80.8929C80.6549 28.4516 80.3941 28.3846 80.195 28.2683V28.411ZM80.195 27.6197C80.232 27.9123 80.4681 28.0956 80.8629 28.0956C81.2506 28.0956 81.4798 27.8823 81.4798 27.5351C81.4798 27.1897 81.2506 26.9764 80.8629 26.9764C80.4681 26.9764 80.232 27.1597 80.195 27.4505V27.6197Z",
    fill: "#182C61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5543 25.5113C86.9839 25.4872 87.5188 25.6011 87.925 25.7435C87.9231 25.9719 87.9212 26.2004 87.9193 26.4293C87.7217 26.4591 87.7174 26.3721 87.5983 26.3044C87.2356 26.1006 86.7169 25.9606 86.3136 26.1233C85.9629 26.2647 85.9308 26.6908 86.1528 26.8148C86.594 27.0602 87.9174 26.8715 88.0514 27.852C88.1035 28.2332 88.0136 28.5278 87.7131 28.7757C87.0786 29.2987 86.0619 29.1427 85.3672 28.8154C85.3691 28.5832 85.371 28.3509 85.3729 28.1182C85.6007 28.0832 85.6346 28.1953 85.7973 28.288C86.1576 28.4938 86.6227 28.6673 87.0361 28.5146C87.2916 28.4205 87.5088 28.1178 87.3858 27.8742C87.2279 27.5616 86.2595 27.5729 85.9346 27.4263C85.004 27.0068 85.2485 25.5855 86.5543 25.5113Z",
    fill: "#182C61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5619 25.5113C88.7743 25.5132 88.9863 25.5151 89.1987 25.517C89.2006 25.9573 89.2025 26.3971 89.2045 26.8375H90.6269C90.6288 26.3971 90.6307 25.9573 90.6327 25.517H91.2638C91.2618 26.7164 91.2599 27.9158 91.258 29.1152C91.0494 29.1133 90.8413 29.1115 90.6327 29.1096C90.6307 28.5486 90.6288 27.9877 90.6269 27.4268H89.2045C89.2025 27.9877 89.2006 28.5486 89.1987 29.1096H88.5561C88.5581 27.9101 88.56 26.7107 88.5619 25.5113Z",
    fill: "#182C61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8651 25.8627V26.4634C94.868 26.5097 94.6852 26.505 94.6527 26.4974C94.5972 26.4842 94.2604 26.0959 93.6202 26.0552C92.1929 25.9653 92.1236 27.7545 92.8058 28.3216C93.1872 28.639 93.78 28.5803 94.2226 28.4294V27.7834C93.9341 27.7815 93.6451 27.7796 93.3565 27.7777V27.1884C93.8594 27.1922 94.3623 27.196 94.8651 27.1997V28.7525C94.8273 28.8371 94.5412 28.9374 94.435 28.9677C94.0393 29.0817 93.1814 29.1668 92.7948 29.0585C91.9288 28.8159 91.6135 27.5942 91.791 26.82C92.0566 25.6636 93.1805 25.3287 94.2517 25.5903C94.3747 25.6201 94.8211 25.7667 94.8656 25.8622L94.8651 25.8627Z",
    fill: "#182C61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2319 23.2042C34.6507 23.2042 34.1074 23.0939 33.602 22.8734C33.0966 22.653 32.6518 22.3485 32.2677 21.9601C31.8886 21.5663 31.5904 21.107 31.3731 20.5821C31.1608 20.0519 31.0547 19.4797 31.0547 18.8655C31.0547 18.2461 31.1634 17.6765 31.3807 17.1568C31.598 16.6319 31.8962 16.1778 32.2753 15.7946C32.6543 15.4062 33.0915 15.1069 33.5868 14.897C34.0872 14.6817 34.6179 14.5741 35.1789 14.5741C35.6439 14.5741 36.0962 14.6476 36.5359 14.7946C36.9756 14.9363 37.3623 15.1306 37.6958 15.3773L37.0287 16.9049C36.8821 16.7631 36.7103 16.6424 36.5132 16.5427C36.3161 16.4429 36.1063 16.3668 35.8839 16.3143C35.6615 16.2566 35.4417 16.2277 35.2244 16.2277C34.7594 16.2277 34.3449 16.3406 33.981 16.5663C33.6222 16.792 33.3366 17.107 33.1244 17.5112C32.9171 17.9101 32.8135 18.3668 32.8135 18.8813C32.8135 19.3852 32.9171 19.8393 33.1244 20.2435C33.3316 20.6477 33.6171 20.9679 33.981 21.2041C34.3449 21.4351 34.7619 21.5506 35.2319 21.5506C35.6059 21.5506 35.9572 21.485 36.2857 21.3537C36.6193 21.2173 36.8771 21.0598 37.059 20.8813L37.7186 22.4325C37.4254 22.6477 37.0641 22.8315 36.6345 22.9837C36.2049 23.1307 35.7374 23.2042 35.2319 23.2042Z",
    fill: "#182C61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3507 23.2357C41.5825 23.2357 40.8926 23.0519 40.281 22.6845C39.6695 22.3118 39.1843 21.7999 38.8254 21.149C38.4666 20.4928 38.2872 19.7369 38.2872 18.8813C38.2872 18.0309 38.4666 17.2828 38.8254 16.6372C39.1843 15.9915 39.6695 15.4875 40.281 15.1253C40.8926 14.7631 41.5825 14.582 42.3507 14.582C43.129 14.582 43.824 14.7631 44.4355 15.1253C45.0471 15.4875 45.5298 15.9915 45.8835 16.6372C46.2373 17.2828 46.4142 18.0309 46.4142 18.8813C46.4142 19.7369 46.2348 20.4928 45.876 21.149C45.5222 21.7999 45.037 22.3118 44.4204 22.6845C43.8088 23.0519 43.1189 23.2357 42.3507 23.2357ZM42.3507 21.59C42.7955 21.59 43.1922 21.4771 43.541 21.2514C43.8897 21.0257 44.1626 20.7107 44.3597 20.3065C44.5619 19.897 44.663 19.422 44.663 18.8813C44.663 18.3511 44.5644 17.8865 44.3673 17.4876C44.1702 17.0886 43.8973 16.7789 43.5485 16.5584C43.2049 16.3379 42.8081 16.2277 42.3583 16.2277C41.9135 16.2277 41.5168 16.3379 41.168 16.5584C40.8193 16.7789 40.5438 17.0886 40.3417 17.4876C40.1446 17.8865 40.046 18.3511 40.046 18.8813C40.046 19.422 40.1446 19.897 40.3417 20.3065C40.5438 20.7107 40.8168 21.0257 41.1604 21.2514C41.5092 21.4771 41.9059 21.59 42.3507 21.59Z",
    fill: "#182C61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8471 23.1097V14.708H49.5832V15.7395H49.8637L49.2117 16.5584C49.4391 15.9285 49.7778 15.4429 50.2276 15.1017C50.6774 14.7552 51.2056 14.582 51.8121 14.582C52.3781 14.582 52.8557 14.7316 53.2449 15.0308C53.6391 15.3248 53.9171 15.7211 54.0788 16.2198L53.6012 15.7631H54.2532L53.6695 16.2198C53.9222 15.6686 54.2936 15.2592 54.7839 14.9915C55.2741 14.7185 55.8074 14.582 56.3835 14.582C56.8738 14.582 57.2907 14.6686 57.6344 14.8419C57.9832 15.0151 58.2637 15.2487 58.4759 15.5426C58.6933 15.8366 58.8525 16.17 58.9536 16.5427C59.0597 16.9101 59.1128 17.2907 59.1128 17.6844V23.1097H57.316V17.9757C57.316 17.3931 57.1897 16.9521 56.937 16.6529C56.6843 16.3484 56.3406 16.1962 55.9059 16.1962C55.6279 16.1962 55.3727 16.2618 55.1402 16.3931C54.9077 16.5243 54.7207 16.7211 54.5792 16.9836C54.4427 17.2461 54.3745 17.5768 54.3745 17.9757V23.1097H52.5853V17.9757C52.5853 17.3931 52.4565 16.9521 52.1987 16.6529C51.946 16.3484 51.6023 16.1962 51.1677 16.1962C50.7482 16.1962 50.3868 16.3484 50.0835 16.6529C49.7853 16.9574 49.6362 17.4114 49.6362 18.0151V23.1097H47.8471Z",
    fill: "#182C61"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9171 26.4168V14.708H62.6532V15.6844H62.8882L62.494 16.519V21.1648L63.0019 22.1254H62.7063V26.4168H60.9171ZM65.155 23.2357C64.4777 23.2357 63.8712 23.0441 63.3355 22.6608C62.8048 22.2776 62.3853 21.7553 62.077 21.0939C61.7687 20.4325 61.612 19.6897 61.607 18.8655C61.612 18.0414 61.7637 17.3065 62.0619 16.6608C62.3651 16.0098 62.7796 15.498 63.3052 15.1253C63.8359 14.7526 64.4424 14.5663 65.1247 14.5663C65.7564 14.5663 66.3503 14.7369 66.9063 15.0781C67.4622 15.4193 67.9095 15.9127 68.2481 16.5584C68.5918 17.2041 68.7586 17.9889 68.7485 18.9128C68.7535 19.6004 68.6575 20.2146 68.4604 20.7553C68.2633 21.2908 67.9954 21.7422 67.6568 22.1097C67.3182 22.4771 66.9315 22.758 66.4969 22.9522C66.0673 23.1412 65.62 23.2357 65.155 23.2357ZM64.7835 21.6293C65.2081 21.6293 65.5871 21.5112 65.9207 21.275C66.2543 21.0388 66.512 20.7159 66.694 20.3065C66.881 19.8918 66.972 19.4193 66.9669 18.8891C66.972 18.3432 66.881 17.8681 66.694 17.4639C66.507 17.0545 66.2442 16.7369 65.9055 16.5112C65.572 16.2854 65.1904 16.1752 64.7608 16.1805C64.3564 16.1752 63.99 16.2828 63.6615 16.5033C63.338 16.7185 63.0777 17.0282 62.8806 17.4324C62.6886 17.8366 62.5925 18.3222 62.5925 18.8891C62.5925 19.4193 62.686 19.8918 62.8731 20.3065C63.0651 20.7159 63.3254 21.0388 63.6539 21.275C63.9824 21.5112 64.359 21.6293 64.7835 21.6293Z",
    fill: "#182C61"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0691 23.2357C71.6445 23.2357 71.2933 23.1412 71.0153 22.9522C70.7424 22.7632 70.5377 22.5007 70.4012 22.1648C70.2647 21.8288 70.1965 21.4404 70.1965 20.9994V10.9835H71.9857V20.8498C71.9857 20.9705 71.9983 21.0886 72.0236 21.2041C72.0489 21.3196 72.0994 21.4167 72.1752 21.4955C72.2561 21.569 72.3824 21.6057 72.5543 21.6057C72.625 21.6057 72.6882 21.6005 72.7438 21.59C72.8044 21.5742 72.8575 21.5585 72.903 21.5427V23.0939C72.7969 23.1412 72.668 23.1753 72.5164 23.1963C72.3698 23.2225 72.2207 23.2357 72.0691 23.2357Z",
    fill: "#182C61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3283 23.1097V14.708H76.1174V23.1097H74.3283ZM75.2229 13.5347C74.8842 13.5347 74.5987 13.414 74.3662 13.1725C74.1387 12.9311 74.025 12.6371 74.025 12.2906C74.025 11.9442 74.1387 11.6502 74.3662 11.4087C74.5987 11.1673 74.8842 11.0465 75.2229 11.0465C75.5564 11.0465 75.8395 11.1673 76.0719 11.4087C76.3044 11.6502 76.4207 11.9442 76.4207 12.2906C76.4207 12.6371 76.3044 12.9311 76.0719 13.1725C75.8395 13.414 75.5564 13.5347 75.2229 13.5347Z",
    fill: "#182C61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7156 22.9081L81.9232 11.6198H83.6311L87.8077 22.9081H86.0221L83.5379 16.1028C83.5069 16.0276 83.4448 15.8448 83.3516 15.5546C83.2688 15.2643 83.1705 14.9418 83.0566 14.587C82.9428 14.2322 82.8392 13.9097 82.7461 13.6194C82.6529 13.3184 82.5908 13.1249 82.5598 13.0389L82.9169 13.0227C82.8548 13.2055 82.7771 13.4366 82.684 13.7162C82.6012 13.9957 82.508 14.2913 82.4045 14.6031C82.3114 14.9149 82.2182 15.2105 82.125 15.49C82.0319 15.7588 81.9542 15.9846 81.8921 16.1673L79.4235 22.9081H77.7156ZM79.5787 20.1021L80.1998 18.425H85.1371L85.8514 20.1021H79.5787Z",
    fill: "#182C61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3168 22.9081V21.2955H91.0712V13.2324H89.3168V11.6198H94.5026V13.2324H92.7481V21.2955H94.5026V22.9081H89.3168Z",
    fill: "#182C61"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3135_25318",
    x: 1.46982,
    y: 4.32545,
    width: 23.8317,
    height: 28.5921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00346,
    dy: 1.00346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08709
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3135_25318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3135_25318",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.501732,
    dy: -0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.309401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3135_25318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3135_25318",
    x: 5.96214,
    y: 7.25222,
    width: 16.3533,
    height: 21.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.501732,
    dy: 0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.878031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3135_25318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_3135_25318",
    x: 19.4827,
    y: 4.8223,
    width: 6.76175,
    height: 7.53522,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.422615,
    dy: 0.84523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3135_25318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3135_25318",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.773385,
    dy: -0.773385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3135_25318"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_3135_25318",
    x: 6.36386,
    y: 12.1292,
    width: 15.2484,
    height: 12.4587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0272251 0 0 0 0 0.0125 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3135_25318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3135_25318",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.308509
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3135_25318"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.338092,
    dy: -0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.393032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3135_25318",
    result: "effect3_innerShadow_3135_25318"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLogo);
export default __webpack_public_path__ + "static/media/report-logo.7d99e60681ed502c3e2f3ab5a87e9e51.svg";
export { ForwardRef as ReactComponent };